import { ProfileRoles } from '@bp/pim-auth-constants';
import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { organizationRolesAsString } from 'utils/organizationRolesAsString';
import { PersonForm } from '../forms/PersonForm';

type PersonModalProps = {
  uuid?: string;
  role: ProfileRoles;
  isOpen: boolean;
  onClose: () => void;
};

export const PersonModal = ({ uuid, role, isOpen, onClose }: PersonModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  const roleAsString = organizationRolesAsString([role]);

  return (
    <Modal
      width='s'
      title={uuid ? t('persons.editRole', { role: roleAsString }) : t('persons.addRole', { role: roleAsString })}
      loading={loading}
      isOpen={isOpen}
      onRequestClose={() => onClose()}
    >
      <PersonForm uuid={uuid} role={role} onLoad={(loading) => setLoading(loading)} onClose={() => onClose()} />
    </Modal>
  );
};
